<template>
  <div style="width:90%">
		<div class="container_body">
      <header class="header_nav">
        <el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
          <el-form-item label="用户ID" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
          <el-form-item label="用户名" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.userName" placeholder="请输入用户名"></el-input>
					</el-form-item>
          <el-form-item label="预约状态" class='tiny' cleartable>
            <el-select clearable  v-model="searchInfo.status" placeholder="请选择状态"
						style="width:150px;">
							<el-option v-for="item in statusList" :key="item.value" :label="item.name"
							:value="item.value"></el-option>
						</el-select>
					</el-form-item>
          <el-form-item>
            <template>
              <el-button type="primary" @click="searchRecordsData">查询</el-button>
							<el-button  @click="empty">清空</el-button>
            </template>
          </el-form-item>
        </el-form>
      </header>
    </div>
    <el-table :data="recordsData"  style="width: 100%"  v-loading="loading" element-loading-text="拼命加载中" 
    element-loading-spinner="el-icon-loading" :header-cell-style="headClass">
          <el-table-column property="userId" fixed label="用户ID" width="150" align="center"></el-table-column>
          <el-table-column property="userName" fixed label="用户名" width="150" align="center"></el-table-column>
          <el-table-column property="goodsName" fixed label="预约商品" :show-overflow-tooltip="true" width="200" align="center"></el-table-column>
          <el-table-column property="subscribeAmount" label="预约金额" width="150" align="center"></el-table-column>
          <el-table-column property="status" label="预约状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">已预约</span>
              <span v-if="scope.row.status === 1">已完成</span>
              <span v-if="scope.row.status === 2">已取消</span>
            </template>
          </el-table-column>
          <el-table-column property="createTime" label="预约时间" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column property="pairTime" label="抢购预约成功时间" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="isChoose" label="是否抢中" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isChoose === false">否</span>
              <span v-if="scope.row.isChoose === true">是</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="isCheck" label="是否设置必中" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.isCheck === false">否</span>
              <span v-if="scope.row.isCheck === true">是</span>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination  background :current-page="page.pageNum"
            @current-change="pageChangeRecords" layout="total, sizes, prev, pager, next, jumper" :total="recordsTotal"
            @size-change="handleSizeChangeRecords" :page-sizes="[10, 20, 50, 100]">
        </el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchInfo: {},
      recordsData: [],
      recordsID: '',
      recordsTotal: 0,
      searchRecordsInfo:{},
      page: {
					pageNum: 1,
					pageSize: 10
			},
      loading: false,
      statusList: [
        {
          value: '0',
          name: '已预约'
        },
        {
          value: '1',
          name: '已完成'
        },
        {
          value: '2',
          name: '已取消'
        },
      ],
    }
  },
  methods: {
    pageChangeRecords(val) {
      this.page.pageNum = val
      this.getRecordsList()
    },
    handleSizeChangeRecords(val) {
      this.page.pageSize = val
      this.getRecordsList()
    },
    getRecordsList() {
      this.loading = true
      let data = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }
      this.$api.getSubscribeRecordList(data).then(res => {
        console.log(res.data)
        if(res.state == 'success'){
          this.loading = false
          this.recordsData = res.data.list
          this.recordsTotal = res.data.total
        }
      })
    },
    headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
		},
    searchRecordsData() {
      let obj = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }
      let data = Object.assign(this.searchInfo,obj)
      this.$api.getSubscribeRecordList(data).then(res => {
        if(res.state == 'success'){
          this.recordsData = res.data.list
          this.recordsTotal = res.data.total
        }
      })
    },
    empty() {
      this.searchInfo = {}
    },
  },
  created() {
    this.getRecordsList()
  }
  
}
</script>